module.exports = __webpack_public_path__ + "images/userIcon.c2a37f4fc5bf0274bba6d5329bae4b8a.png";